import { render, staticRenderFns } from "./TwoFaVerify.vue?vue&type=template&id=99beae60&scoped=true"
import script from "./TwoFaVerify.vue?vue&type=script&lang=js"
export * from "./TwoFaVerify.vue?vue&type=script&lang=js"
import style0 from "./TwoFaVerify.vue?vue&type=style&index=0&id=99beae60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99beae60",
  null
  
)

export default component.exports